<template>
  <div class="myTable">
    <div class="searchNav" >
      <el-button class="newAdd" type="primary" v-if="$can('dev-app-stat:add')" @click="addApp" icon="el-icon-plus" > 新增软件版本</el-button>
      <span><span class="searchNameStyle">版本名 ：</span><el-input v-model="searchInfo.versionName" clearable placeholder="请输入"></el-input></span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick">
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
<!--        <el-table-column prop="appName" label="app名称"></el-table-column>-->
<!--        <el-table-column prop="versionName" label="版本名"></el-table-column>-->
        <el-table-column prop="versionCode" label="版本号"></el-table-column>
<!--        <el-table-column prop="packgeName" label="包名"></el-table-column>-->
<!--        <el-table-column prop="versionUrl" label="保存路径"></el-table-column>-->
        <el-table-column prop="describeInfo" label="描述"></el-table-column>
        <el-table-column prop="versionSize" label="文件大小">
            <template slot-scope="scope">
                {{ formatFileSize(scope.row.versionSize) }}
            </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('dev-app-stat:download')" @click="downloadFile(scope.row.versionUrl)">下载</el-button>
            <el-button type="text" size="small" v-if="$can('dev-app-stat:edit')" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="$can('dev-app-stat:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div class="addInfoStyle">
<!--          <div><span class="required-star">*</span> <span>app名称：</span><el-input v-model="addInfo.appName" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>-->
<!--          <div><span class="required-star">*</span> <span>版本名：</span><el-input v-model="addInfo.versionName" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>-->
          <div><span class="required-star">*</span> <span>版本号：</span><el-input v-model="addInfo.versionCode" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>
<!--          <div><span class="required-star">*</span> <span>包名：</span><el-input v-model="addInfo.packgeName" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>-->
          <div><span class="required-star">*</span> <span>上传：</span>
            <el-upload style="    padding-left: 39px;width: 80%;"
                       :action="uploadFileUrl"
                       :limit="1"
                       :file-list="appList"
                       :on-success	="uploadSuccess"
                       :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div><span class="required-star">*</span> <span>描述：</span><el-input v-model="addInfo.describeInfo" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>
<!--          <div><span class="required-star">*</span> <span>文件大小：</span><el-input v-model="addInfo.versionSize" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>-->
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" v-loading="formLoading" @click="save">提 交</el-button>
              </span>
      </el-dialog>
    </div>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import RichTextEditor from '../util/RichTextEditor';

  export default {
    name: "white-list",
    components: {
      RichTextEditor
    },
    data () {
      return {
        dialogTitle:'新增设备软件',
        total:1,
        tableData: [],
        appList: [],
        loading: false,
        formLoading: false,
        uploadFileUrl:this.baseURL+'devApp/upload',
        dialogVisible: false,
        infoDialogVisible: false,
        currentPage:1,
        roleList:'',
        addInfo:{
          // appName:'',
          versionName:'',
          versionCode:'',
          packgeName:'',
          versionUrl:'',
          describeInfo:'',
          versionSize:''
        },
        searchInfo:{
          versionName:'',
          pageNumber:1,
          pageSize:50,
        },
      }
    },
    watch: {
      'searchInfo.title'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
    },
    created: function () {
      this.pageInfo();
    },
    methods:{
      search(){
        this.pageInfo();
      },
//改为全局方法
      // 获取编辑器中的内容
      handleContentChange(newContent) {
        this.addInfo.content = newContent;
      },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.currentPage = 0;
            this.searchInfo.pageSize = val ;
            this.pageInfo();
        },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      validate(){

        let flag = true;
        let msg  = "";
        return {code:flag,msg:msg}
      },
      save(){
        if (this.formLoading)  return; // 防止重复提交
        this.formLoading=true;
        let validateData = this.validate();
        if(!validateData.code){
          this.$message({
            message: validateData.msg,
            type: 'warning'
          });
          return;
        }
        console.info("---------")
        if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
            axios.post('/devApp',this.addInfo).then(result => {
              this.formLoading=false;
              this.dialogVisible = false;
              if (result.code !== 200){
                console.log(result);
              }
              this.clearObj(this.addInfo); // 清空新增数据
              this.pageInfo();
            }).catch(err => {
              this.formLoading=false;
              console.log(err);
            });
        }else{  // 编辑
            // 当前系列 是开启的
            axios.put('/devApp',this.addInfo).then(result => {
              this.formLoading=false;
              this.dialogVisible = false;
              if (result.code !== 200){
                console.log(result);
              }
              this.pageInfo();

              this.clearObj(this.addInfo); // 清空新增数据
              this.addInfo.id = undefined;
              this.dialogTitle="新增设备软件";
            }).catch(err => {
              this.formLoading=false;
              console.log(err);
            });
        }
      },
        addApp(){
            this.dialogVisible = true;
            this.clearObj(this.addInfo); // 清空新增数据
            this.appList = [];
        },
      uploadSuccess(res, file) {
        if (res.code == 200){
          this.addInfo.versionUrl=res.data;
          this.addInfo.versionSize = file.size; // 获取文件大小
        } else {
          this.Message.error("图片上传失败")
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      remove(id){
        axios.delete('/devApp',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      confirmRemove(id){
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      handleRowDblClick(row, column, event) {

        this.addInfo =JSON.parse(JSON.stringify(row));
        this.infoDialogVisible = true;
      },
        downloadFile(filePath) {
            const link = document.createElement('a');
            link.href = filePath;
            link.setAttribute('download', ''); // 可以指定下载文件名，例如 'downloadName.pdf'
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
      edit(obj){
        this.dialogTitle = "设备软件编辑";
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.dialogVisible = true;
        this.appList = [];
          if (obj.versionUrl != null && obj.versionUrl != ''){
              this.appList.push({
                  name: this.dealPictureRelativeUrl(obj.versionUrl),
                  url: obj.versionUrl
              });
          }
      },
      pageInfo(){
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/devApp',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;
          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },
      formatFileSize(fileSizeBytes) {
          const sizeInKB = fileSizeBytes / 1024;
          const sizeInMB = fileSizeBytes / (1024 * 1024);

          // 判断大小并返回对应的格式化字符串
          if (sizeInMB >= 1) {
              return sizeInMB.toFixed(2) + ' MB'; // 四舍五入到小数点后两位，并添加单位 MB
          } else {
              return sizeInKB.toFixed(2) + ' KB'; // 四舍五入到小数点后两位，并添加单位 KB
          }
    }
    },filters: {
      showState(val){
        if (val == 1){
          return "已处理";
        }
        return "未处理"
      },
      consumerState(val){
        if (val){
          return "禁用";
        }
        return "开启"
      }
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
</style>
